var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.5C12 19.2239 12.2239 19 12.5 19H13.5C13.7761 19 14 19.2239 14 19.5C14 19.7761 13.7761 20 13.5 20H12.5C12.2239 20 12 19.7761 12 19.5Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19C15.2239 19 15 19.2239 15 19.5C15 19.7761 15.2239 20 15.5 20H16.5C16.7761 20 17 19.7761 17 19.5C17 19.2239 16.7761 19 16.5 19H15.5Z",
    fill: "#00112B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.5C12 17.2239 12.2239 17 12.5 17H13.5C13.7761 17 14 17.2239 14 17.5C14 17.7761 13.7761 18 13.5 18H12.5C12.2239 18 12 17.7761 12 17.5Z",
    fill: "#00112B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17C15.2239 17 15 17.2239 15 17.5C15 17.7761 15.2239 18 15.5 18H16.5C16.7761 18 17 17.7761 17 17.5C17 17.2239 16.7761 17 16.5 17H15.5Z",
    fill: "#00112B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.5C19 12.2239 19.2239 12 19.5 12C19.7761 12 20 12.2239 20 12.5V19.5C20 19.7761 19.7761 20 19.5 20C19.2239 20 19 19.7761 19 19.5V12.5Z",
    fill: "#00112B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15C12.2239 15 12 15.2239 12 15.5C12 15.7761 12.2239 16 12.5 16H13.5C13.7761 16 14 15.7761 14 15.5C14 15.2239 13.7761 15 13.5 15H12.5Z",
    fill: "#00112B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.5C15 15.2239 15.2239 15 15.5 15H16.5C16.7761 15 17 15.2239 17 15.5C17 15.7761 16.7761 16 16.5 16H15.5C15.2239 16 15 15.7761 15 15.5Z",
    fill: "#00112B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12C12.2239 12 12 12.2239 12 12.5V13.5C12 13.7761 12.2239 14 12.5 14H16.5C16.7761 14 17 13.7761 17 13.5V12.5C17 12.2239 16.7761 12 16.5 12H12.5Z",
    fill: "#00112B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9C10.4477 9 10 9.44772 10 10V22C10 22.5523 10.4477 23 11 23H21C21.5523 23 22 22.5523 22 22V10C22 9.44772 21.5523 9 21 9H11ZM21 10H11V22H21V10Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPos);
export default __webpack_public_path__ + "static/media/pos.248693e51e883f061bf84f0699723683.svg";
export { ForwardRef as ReactComponent };